<div class="avatar-container">
  <div class="avatar" [class.small]="size === 'small'" [style.background-color]="generateBackgroundColor(input)">{{ getInitials(input) }}</div>
</div>
